import { identityTypeToLabel } from "@p0security/shared/assessment/constants";
import { Identity } from "@p0security/shared/types/assessment/data/index";

import { identityTypeToEmoji } from "./shared";

export const MemberIdentityDisplay = ({ identity }: { identity: Identity }) => (
  <>
    {identityTypeToEmoji[identity.type]}
    &nbsp;
    {identity.type === "public"
      ? identityTypeToLabel(identity)
      : identity.label}
  </>
);
